import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FormlyModule } from '@ngx-formly/core';
import { NgxMaskDirective } from 'ngx-mask';

import {
  AddressPipe,
  ButtonModule,
  CurrencyMaskDirective,
} from '@lockton-apps/shared/ui/lui';
import { ClearOnFocusDirective } from '@lockton-apps/shared/util/form-utils';

import { ArrayTypeComponent } from './array-type.component';
import { MatIconModule } from '@angular/material/icon';
import { GetPipe, IsNilPipe } from '@lockton-apps/shared/util/ng-lodash';
import { LetDirective } from '@ngrx/component';

@NgModule({
  declarations: [ArrayTypeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    NgxMaskDirective,
    CurrencyMaskDirective,
    ButtonModule,
    MatIconModule,
    GetPipe,
    AddressPipe,
    LetDirective,
    IsNilPipe,
    FormlyModule.forChild({
      types: [
        {
          name: 'array',
          component: ArrayTypeComponent,
        },
      ],
    }),
    ClearOnFocusDirective,
  ],
})
export class ArrayTypeModule {}
